import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';

// Constants
import { ROUTE_NAMES, ROUTE_PATHS } from '../../constants/routes';

// Components
import Tabs, { Tab } from '../../components/Tabs';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

// Component
export interface IProps {
    currentRouteName: string;
    onNavigate: (routeName: string) => void;
}
class PeopleToolbar extends React.Component<IProps, {}> {
    @computed
    get tabIndex(): number {
        const segment = this.props.currentRouteName.split('.')[3];
        switch (segment) {
            case ROUTE_NAMES.APP_NETWORK_PEOPLE_SEARCH:
                return 0;
            case ROUTE_NAMES.APP_NETWORK_PEOPLE_STATISTICS:
                return 1;
            case ROUTE_NAMES.APP_NETWORK_PEOPLE_MYTAGS:
                return 2;
            default:
                return 0;
        }
    }

    handleTabChange = (e: React.ChangeEvent<{}>, index: number) => {
        if (index === 0) {
            this.props.onNavigate(ROUTE_PATHS.APP_NETWORK_PEOPLE_SEARCH);
        } else if (index === 1) {
            this.props.onNavigate(ROUTE_PATHS.APP_NETWORK_PEOPLE_STATISTICS);
        } else if (index === 2) {
            this.props.onNavigate(ROUTE_PATHS.APP_NETWORK_PEOPLE_MYTAGS);
        }
    }

  render() {
    return (
      <Toolbar>
        <Typography type="title" style={{ flexGrow: 1 }}>
          People
        </Typography>
        <div style={{ flexGrow: 1 }}>
          <Tabs value={this.tabIndex} onChange={this.handleTabChange}>
            <Tab value={0} label="Search" style={{ height: 64 }} />
            <Tab value={1} label="Statistics" style={{ height: 64 }} />
            <Tab value={2} label="My Tags" style={{ height: 64 }} />
          </Tabs>
        </div>
      </Toolbar>
    );
  }
}

export default observer(PeopleToolbar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeople/PeopleToobar.tsx